import React, { useContext } from 'react'
import { Context } from '../components/common/BaseContext'

export function useModal(component, styles) {
    const { setModalComponent } = useContext(Context)

    function showModal(props) {
        const content = React.isValidElement(component) ? React.cloneElement(component, props) : component(props)
        setModalComponent({ content, styles })
    }

    function hideModal() {
        setModalComponent(null)
    }

    return [showModal, hideModal]
}
